<button
  class="btn btn__solid {{ styleClasses }}"
  [class.large]="large"
  [disabled]="disabled"
  [class.uppercase]="uppercase"
  [class.fill-all-space]="fillAllSpace"
  (click)="onSubmit($event)">
  <i *ngIf="withIcon" class="icon btn-icon {{ iconClass }}"></i>
  <span>{{ buttonLabel | translate }}</span>

  <ng-content></ng-content>
</button>
